import { OnInit } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { EventsService } from '../../core/services/events-service/events.service';
import { ProfileService } from '../../core/services/profile-service/profile.service';
import { DayOfService } from '../../core/services/day-of.service';
import { AlertComponent, scrollItType } from '../../shared';
var SubmitProtestComponent = /** @class */ (function () {
    function SubmitProtestComponent(fb, scrollIt, eventService, route, profileService, dayOfService) {
        this.fb = fb;
        this.scrollIt = scrollIt;
        this.eventService = eventService;
        this.route = route;
        this.profileService = profileService;
        this.dayOfService = dayOfService;
        this.showValidation = false;
        this.eventId = '';
        this.payload = null;
        this.successHtml = '';
        this.price = '200';
        this.competitors = [];
    }
    Object.defineProperty(SubmitProtestComponent.prototype, "eventUrl", {
        get: function () {
            return this.eventService.eventData.url;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SubmitProtestComponent.prototype, "isClosed", {
        get: function () {
            return this.eventService.isRegistrationClosed('submit-protest');
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SubmitProtestComponent.prototype, "formState", {
        get: function () {
            if (this.successHtml) {
                return 'RESET_FORM';
            }
            return 'PAY';
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SubmitProtestComponent.prototype, "isProcessorPaymentCode", {
        get: function () {
            return this.eventService.eventData.processors.payment_codes;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SubmitProtestComponent.prototype, "isProcessorPayPal", {
        get: function () {
            return !!this.eventService.eventData.processors.paypal;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SubmitProtestComponent.prototype, "isProcessorAuthNet", {
        get: function () {
            return !!this.eventService.eventData.processors.authorize_net;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SubmitProtestComponent.prototype, "stripePublicKey", {
        get: function () {
            return this.eventService.eventData.processors.stripe.pk;
        },
        enumerable: true,
        configurable: true
    });
    SubmitProtestComponent.prototype.ngOnInit = function () {
        // this.initForm();
        this.eventId = this.route.snapshot.parent.params.id;
        this.payload = { school: { id: '100' } };
        // this.dummyResponse(); // todo - remove
    };
    SubmitProtestComponent.prototype.initForm = function () {
        this.form = this.fb.group({
            competitor_id: ['', Validators.required],
            division_id: ['', Validators.required],
        });
    };
    SubmitProtestComponent.prototype.search = function (query) {
        var _this = this;
        this.alert.closeAlert();
        this.resetForm();
        this.competitors = null;
        // this.resetPage();
        if (!(query.name_first && query.name_last)) {
            return;
        }
        this.dayOfService
            .weighInSearch(this.eventId, {
            name_first: query.name_first,
            name_last: query.name_last,
            id: null,
        })
            .subscribe(function (res) {
            _this.competitors = res.competitors;
            _this.alert.newAlert(res.html, 'info');
            // this.dummyResponse(); // TODO - remove
        }, function (error) {
            if (error && error.error && error.error.detail) {
                _this.alert.newAlert(error.error.detail, 'warning');
            }
            else {
                _this.alert.newAlert('Something went wrong', 'danger');
            }
        });
    };
    SubmitProtestComponent.prototype.dummyResponse = function () {
        var _this = this;
        setTimeout(function () {
            _this.competitors = getDummyResponse().competitors;
            _this.alert.newAlert(getDummyResponse().html, 'info');
        }, 500);
    };
    SubmitProtestComponent.prototype.selectButtonContext = function (competitor, division) {
        if (this.isSelected(competitor, division)) {
            return 'success';
        }
        return 'default';
    };
    SubmitProtestComponent.prototype.isSelected = function (competitor, division) {
        return (this.form.get('competitor_id').value === competitor.id &&
            this.form.get('division_id').value === division.id);
    };
    SubmitProtestComponent.prototype.clickCompetitor = function (member, division) {
        this.resetForm();
        if (!division.allowed) {
            return;
        }
        console.log({ member: member, division: division });
        this.form.patchValue({
            competitor_id: member.id,
            division_id: division.id,
        });
    };
    SubmitProtestComponent.prototype.usePaypal = function () {
        this.preparePayload();
    };
    SubmitProtestComponent.prototype.preparePayload = function () {
        this.alert.closeAlert();
        // if (this.form.invalid) {
        // 	this.scrollIt(0);
        // 	this.alert.newAlert('Please select a competitor', 'danger');
        // 	this.showValidation = true;
        // 	return false;
        // }
        return true;
    };
    SubmitProtestComponent.prototype.useStripe = function () {
        if (this.preparePayload()) {
            this.payByStripeModal.open();
        }
    };
    SubmitProtestComponent.prototype.onSuccess = function (successHtml) {
        this.scrollIt(0);
        this.successHtml = successHtml;
    };
    SubmitProtestComponent.prototype.onError = function () {
        this.scrollIt(0);
        this.alert.newAlert('There was an error in processing your payment', 'danger');
    };
    SubmitProtestComponent.prototype.resetForm = function () {
        this.successHtml = '';
        this.showValidation = false;
    };
    return SubmitProtestComponent;
}());
export { SubmitProtestComponent };
function getDummyResponse() {
    return {
        status: 'OK',
        competitors: [
            {
                id: '19387',
                uuid: 'b49de655-aa50-4b49-9cea-84acade8da55',
                code: '',
                email: 'angelinahbdz@yahoo.com',
                name_first: 'ADRIAN',
                name_middle: '',
                name_last: 'ESTRADA',
                address: '1367 Walnut Street',
                address_2: '',
                city: 'Los angeles',
                state: 'CA',
                zip: '90011',
                country: '',
                phone: '(323) 327-7846',
                birth_date: '2004-09-07',
                gender: 'M',
                weight: '125.00',
                height_ft: '5',
                height_in: '2',
                subscription: 'Y',
                document_id: null,
                noc: null,
                shirt_size: '',
                parent_name_first: 'Angelina',
                parent_name_middle: '',
                parent_name_last: 'Hernandez',
                parent_email: 'angelinahbdz@yahoo.com ',
                parent_phone: '(323) 327-7846',
                rank: '3',
                exhibition: 'Y',
                division_01: '0',
                division_02: '335',
                division_03: '0',
                division_04: '0',
                division_05: '0',
                division_06: '0',
                division_07: '0',
                division_08: '0',
                division_09: '0',
                member_usat: null,
                status: null,
                printed: 'N',
                name: 'Adrian ESTRADA',
                rank_name: 'Black Belt',
                school: { id: '25739', name: "Villa's Taekwondo" },
                division_1_name: 'Light',
                division_1_discipline: 'Black Belt Sparring',
                division_1_category: "Men's Individual",
                weigh_in_required: true,
                rebracket_required: false,
                messages: [],
                allowed: true,
                divisions: [
                    {
                        id: '335',
                        allowed: true,
                        name: 'Black Belt Sparring Light M',
                        note: 'Must Weigh In',
                    },
                ],
            },
            {
                id: '32399',
                uuid: 'b49de655-aa50-4b49-9cea-84acade8da55',
                code: '',
                email: 'angelinahbdz@yahoo.com',
                name_first: 'Blah',
                name_middle: '',
                name_last: 'User',
                address: '1367 Walnut Street',
                address_2: '',
                city: 'Los angeles',
                state: 'CA',
                zip: '90011',
                country: '',
                phone: '(323) 327-7846',
                birth_date: '2004-09-07',
                gender: 'M',
                weight: '125.00',
                height_ft: '5',
                height_in: '2',
                subscription: 'Y',
                document_id: null,
                noc: null,
                shirt_size: '',
                parent_name_first: 'Angelina',
                parent_name_middle: '',
                parent_name_last: 'Hernandez',
                parent_email: 'angelinahbdz@yahoo.com ',
                parent_phone: '(323) 327-7846',
                rank: '3',
                exhibition: 'Y',
                division_01: '0',
                division_02: '335',
                division_03: '0',
                division_04: '0',
                division_05: '0',
                division_06: '0',
                division_07: '0',
                division_08: '0',
                division_09: '0',
                member_usat: null,
                status: null,
                printed: 'N',
                name: 'Adrian ESTRADA',
                rank_name: 'Black Belt',
                school: { id: '25739', name: "Villa's Taekwondo" },
                division_1_name: 'Light',
                division_1_discipline: 'Black Belt Sparring',
                division_1_category: "Men's Individual",
                weigh_in_required: true,
                rebracket_required: false,
                messages: [],
                allowed: true,
                divisions: [
                    {
                        id: '24342',
                        allowed: true,
                        name: 'Black Belt Sparring Light M',
                        note: 'Must Weigh In',
                    },
                    {
                        id: '34234',
                        allowed: true,
                        name: 'Another Division',
                        note: 'Must Weigh In',
                    },
                ],
            },
        ],
        html: '1 Competitors Found',
    };
}
